var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import HppApi from "./api/hpp-api";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../utilities/axios-utility";
import { errorSnackbar } from "../../shared/snackbar-constants";
import { ControlsPage } from "./controls/controls-page";
import GlobalStyles from '@mui/material/GlobalStyles';
export var CheckOutPage = function (_a) {
    var options = _a.options;
    var _b = useState(), sessionData = _b[0], setSessionData = _b[1];
    var api = new HppApi(options.environment || 'stage');
    var loadScript = function (src) {
        return new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.onload = function (res) {
                resolve(res);
            };
            script.onerror = function () {
                reject(new Error("Script load error for ".concat(src)));
            };
            document.head.appendChild(script);
        });
    };
    var initScript = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all([
                            loadScript("https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js"),
                            loadScript("https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"),
                        ])];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error loading scripts:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var sessionDataResult, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!options.sessionId) {
                        enqueueSnackbar("SessionId is null", errorSnackbar);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.GetPaymentData(options.sessionId)];
                case 2:
                    sessionDataResult = _a.sent();
                    if (sessionDataResult.code === 200000) {
                        data = sessionDataResult.data;
                        data.options = options;
                        setSessionData(sessionDataResult.data);
                    }
                    else {
                        enqueueSnackbar(sessionDataResult.description, errorSnackbar);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        initScript();
        initData();
    }, []);
    return (sessionData ?
        _jsxs(React.Fragment, { children: [_jsx(GlobalStyles, { styles: {
                        input: { backgroundColor: 'white !important' },
                        select: { backgroundColor: 'white !important' },
                        '.MuiAutocomplete-root': { backgroundColor: 'white !important' },
                        '.MuiInputBase-root': { backgroundColor: 'white !important' },
                    } }), _jsx(ControlsPage, { sessionData: sessionData, api: api })] })
        :
            _jsx(_Fragment, {}));
};
